module.exports = __webpack_public_path__ + "static/media/idlepage-events.cf498a72.svg";